import { useState, useEffect } from "react";

export interface MapSource {
    collectSourceById(id: string): MapSourceType;
}

interface MapSourceType {
    id: string;
    type: string;
    url: string;
    name: string;
}

type MapSourcePropertyType = {
    type: string;
    url: string;
    name: string;
};

const useMapboxSources = () => {
    const [mapboxSource, setSource] = useState<null | MapSource>(null);

    useEffect(() => {
        (function () {
            const mapSources: Map<string, MapSourcePropertyType> = new Map();
            // Collects one source based on id, if not in system throws an error
            // Returns the Map Source specified by id, otherwise throws error
            function collectSourceById(id: string): MapSourceType {
                if (mapSources.has(id)) {
                    const props: MapSourcePropertyType = mapSources.get(id)!;
                    return {
                        id,
                        type: props.type,
                        url: props.url,
                        name: props.name,
                    };
                }
                throw Error(`Source ${id} does not exist.`);
            }
            function getFromJSONString(json_str: string): MapSource {
                try {
                    const sources = JSON.parse(json_str);
                    sources.forEach((source: MapSourceType) => {
                        mapSources.set(source.id, {
                            type: source.type,
                            url: source.url,
                            name: source.name,
                        });
                    });
                    return { collectSourceById };
                } catch (e) {
                    console.error("Error deserializing JSON string: " + e);
                    throw e;
                }
            }
            // Hardcoded json string to be replaced later by Azure storage
            const result = getFromJSONString(`
[
    {
        "id": "bus-location-source",
        "type": "vector",
        "url": "mapbox://grid-insights-mapbox.20mwe1iq",
        "name": "ERCOT_Bus_20241011-dh1evx"
    },
    {
        "id": "transmission-lines-source",
        "type": "vector",
        "url": "mapbox://grid-insights-mapbox.55m1bix3",
        "name": "transmission_lines_tileset_20250513"
    },
    {
        "id": "thermal-capacity-source",
        "type": "vector",
        "url": "mapbox://grid-insights-mapbox.az5ctfc7",
        "name": "thermal_capacity_with_coordin-943noo"
    },
    {
        "id": "load-source",
        "type": "vector",
        "url": "mapbox://grid-insights-mapbox.5skpac06",
        "name": "load_with_coordinates-d6xz0m"
    },
    {
        "id": "generator-operating-source",
        "type": "vector",
        "url": "mapbox://grid-insights-mapbox.2zf08zs2",
        "name": "generator_operating_20241117-1z8fif"
    },
    {
        "id": "generator-planned-source",
        "type": "vector",
        "url": "mapbox://grid-insights-mapbox.7zmla5fk",
        "name": "generator_planned_20241117-d9p5eg"
    },
    {
        "id": "generator-retired-source",
        "type": "vector",
        "url": "mapbox://grid-insights-mapbox.773wgc40",
        "name": "generator_retired_20241117-ccyyfk"
    },
    {
        "id": "queue-iso-source",
        "type": "vector",
        "url": "mapbox://grid-insights-mapbox.b4m5irml",
        "name": "queue_insights_iso_20250516-58nlln"
    }
]
                                                       `);
            setSource(result);
        })();
    }, []);

    return {
        mapboxSource,
    };
};

export default useMapboxSources;
